import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { ClipLoader } from "react-spinners";
import { FaSave, FaChevronLeft, FaEdit, FaTrash } from "react-icons/fa";
import { IoSearchOutline } from "react-icons/io5";
import { Modal, Button, Form } from "react-bootstrap";
import LeaseApiService from '../../services/apiService';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL

const ReverseReceipt = () => {
    const [FilterTab, setFilterTab] = useState(true);
    const [loading, setloader] = useState(false);
    const { currencyPrecision } = useCurrency();

    const [activeTab, setActiveTab] = useState(0);
    const [scondTab, setScodTab] = useState(true);
    const [gridVisibility, setGridVisibility] = useState([true, false, false]);
    const apiService = new LeaseApiService();

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        const newGridVisibility = gridVisibility.map(
            (_, index) => index === tabIndex
        );
        setGridVisibility(newGridVisibility);
    }
    const handleBackClick = () => {
        window.history.back();
    }
    // Tenant
    const [unitList, setUnitList] = useState([])
    const [proprtyList, setProperty] = useState([]);
    const [leaseList, setLeaseList] = useState([]);
    const [narrationList, setNarrationList] = useState([]);
    const [transectionType, setTransectionType] = useState([]);
    const [dataList, setDataList] = useState([]);
    const [selectedTrans, setSelectedTrans] = useState();
    const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }]);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const [alocatedList, setAlocatedList] = useState([{
        allocateAmt: "",
        total: 0,
        allocation: "",
        transectionType: [],
        transectionDate: "",
        payee: "",
        narration: [],
        remarks: "",
    }]);
    useEffect(() => {
        fetchDropdownData();
    }, []);

    const [activeFY, setActiveFY] = useState(null);

    useEffect(() => {
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);

    const [transData, setTransData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
    });
    const [transDetail, setTransDetail] = useState({
        allocateAmt: "",
        total: 0,
        allocation: "",
        transectionType: [],
        transectionDate: "",
        payee: "",
        narration: [],
        remarks: "",
    })
    const [contextMenu, setContextMenu] = useState(null);
    useEffect(() => {
        const today = new Date();
        const formattedToday = today.toISOString().split("T")[0];
        setTransDetail({
            ...transDetail,
            transectionDate: formattedToday,
        });
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);

    }, []);
    const dateFormatter = (params) => {
        const date = moment(params.value);
        return date.format("DD-MMM-YYYY");
    }
    const dateComparator = (date1, date2) => {
        const momentDate1 = moment(date1);
        const momentDate2 = moment(date2);
        return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
    }
    const columnDefs = [{
        checkboxSelection: true,
        headerCheckboxSelection: false,
        suppressMovable: true,
        width: 50,
        pinned: 'left'
    },
    { headerName: 'Lease No', field: 'LeaseNo', filter: true, floatingfilter: true, suppressMovable: true, width: 200, pinned: 'left' },
    { headerName: 'Property', field: 'Property_name', filter: true, floatingfilter: true, suppressMovable: true, width: 280 },
    { headerName: 'Unit No', field: 'Unit_No', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'Tenant Name', field: 'TenantName', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
    { headerName: 'Installment', field: 'Installment_Desc', filter: true, floatingfilter: true, suppressMovable: true, width: 250 },
    { headerName: 'Receipt No', field: 'ReceiptNo', filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Amount Paid', field: 'ActualAmountPaid', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
    { headerName: 'Cheque No', field: 'ChequeNo', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
    { headerName: 'Cheque Status', field: 'CCType', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
    {
        headerName: 'Cheque Date', field: 'ChequeDate',
        valueFormatter: dateFormatter,
        comparator: dateComparator, filter: true, floatingfilter: true, suppressMovable: true, width: 150
    },
    { headerName: 'Drawn Bank', field: 'DrawnOnBank', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
    { headerName: 'Deposite Bank', field: 'BankName', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
    ]
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'LRRSerPropertyName,LRRSerLeaseNos,LRRNarationType,LRRTransactionType');
            const res = await apiService.getApiParamater('REVERSE_MULTI', `?${params.toString()}`);
            setProperty(res?.data?.dropdowns?.LRPSerPropertyName)
            setLeaseList(res?.data?.dropdowns?.LRRSerLeaseNos)
            setNarrationList(res?.data?.dropdowns?.LRRNarationType)
            setTransectionType(res?.data?.dropdowns?.LRRTransactionType)
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handlePropertyChange = async (selectedOption) => {
        const params = new URLSearchParams();
        params.append('DropdownFor', 'LRRUnitNosByPropertyId');
        params.append('CascadValue', selectedOption?.value);
        const res = await apiService.getApiParamater('REVERSE_CASCAD', `?${params.toString()}`);
        setUnitList(res?.data?.items);
        setTransData({
            ...transData,
            Proprty: selectedOption,
            unitNo: [{ label: '', value: '' }],
            leaseNo: [{ label: '', value: '' }]
        });
    }
    const handleUitNo = (selectedOption) => {

        const selectedLease = leaseList?.find((dep) => dep.text === selectedOption?.value);
        setTransData({
            ...transData,
            unitNo: selectedOption,
            leaseNo: { label: selectedLease?.text, value: selectedLease?.value }
        });
    }
    const handleLeaseNo = (selectedOption) => {
        setTransData({
            ...transData,
            leaseNo: selectedOption,
        });
    }
    const handleNarrationChange = (selectedOption) => {
        setTransDetail({
            ...transDetail,
            narration: selectedOption,
        });
    }
    const handleTransectionType = (selectedOption) => {
        setTransDetail({
            ...transDetail,
            transectionType: selectedOption,
        });
    }
    const handleTransSearch = async () => {
        const params = new URLSearchParams();
        params.append('Action', 'GetReceiptDetails');
        if (transData?.Proprty?.value) {
            if (!transData?.unitNo?.value) {
                toast.warning("Please Select Unit No")
                return
            }
        } else if (!transData?.Proprty?.label) {
            if (!transData?.leaseNo?.value) {
                toast.warning("Please Select Lease No")
                return
            }
        }
        params.append('PropertyNo', transData?.Proprty?.value || "");
        params.append('UnitNo', transData?.unitNo?.label || "");
        params.append('LeaseNo', transData?.leaseNo?.label || "");
        const res = await apiService.getApiParamater('REVERSE_COMMON', `?${params.toString()}`);
        setDataList(res?.data?.result?.data);
    }
    const onSelectionChanged = async (event) => {
        const selectedRows = event.api.getSelectedRows();
        const params = new URLSearchParams();
        params.append('Action', 'GetTotalReceiptAmountByLeaseNo');
        params.append('LeaseNo', selectedRows[0]?.LeaseNo || "");
        const res = await apiService.getApiParamater('REVERSE_COMMON', `?${params.toString()}`);
        let total = res?.data?.result?.data?.TotalAmt
        let dta = selectedRows[0]
        setTransDetail({
            ...transDetail,
            dta,
            allocateAmt: dta?.ActualAmountPaid,
            allocation: dta?.ActualAmountPaid,
            total: total
        });
        setSelectedTrans(selectedRows.length === 1 ? selectedRows[0] : null);
    }
    const handleAllocate = async () => {
        const selectedLease = alocatedList?.find((dep) => dep.dta?.LRId === transDetail?.dta?.LRId);
        if (selectedLease) {
            toast.warning("Selected Receipt already added..")
            return
        }
        if (!transDetail?.transectionType?.label) {
            toast.warning("Please Select Transection Type")
            return
        } else if (!transDetail?.transectionDate) {
            toast.warning("Please Enter Transection Date")
            return
        } else if (!transDetail?.remarks) {
            toast.warning("Please Enter Remarks")
            return
        }
        const Invoice = new URLSearchParams();
        Invoice.append('Action', 'chkPostingDateInFinYear');
        Invoice.append('FromDate', transDetail?.transectionDate);

        const Invoiceres = await apiService.getApiParamater('GET_INSTALL_INVOICE_COMMON', `?${Invoice.toString()}`);

        let result = Invoiceres?.data?.result?.data
        if (result?.length === 0) {
            toast.warning("Transection Date should be between Financial Year..!!")
            setloader(false);
            return
        } else if (result?.length > 0) {

            if (!alocatedList[0]?.dta?.Property_No) {
                setAlocatedList(prevEntries => prevEntries.slice(1));
            }
            if (transDetail?.transectionType?.label === "Cheque Return") {
                if (!transDetail?.dta?.ChequeNo) {
                    toast?.warning("Cheque Details not found, Receipt cannot be added")
                    return
                }
            }
            setAlocatedList(prevList => {
                if (!prevList || prevList.length === 0) {
                    return [transDetail];
                } else {
                    return [...prevList, transDetail];
                }
            });

            const today = new Date();
            const formattedToday = today.toISOString().split("T")[0];

            setTransDetail({
                allocateAmt: "",
                total: 0,
                allocation: "",
                transectionType: [],
                transectionDate: formattedToday,
                payee: "",
                narration: [],
                remarks: "",
            });
            setSelectedTrans(); // Assuming this resets selected transaction
        }
    }
    const handleClearFilters = () => {
        setTransData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
        });
        setDataList([])
        setSelectedTrans()
        setUnitList([])
    }
    const handleCleareAllocate = () => {
        const today = new Date();
        const formattedToday = today.toISOString().split("T")[0];
        setTransDetail({
            allocateAmt: "",
            total: 0,
            allocation: "",
            transectionType: [],
            transectionDate: formattedToday,
            payee: "",
            narration: [],
            remarks: "",
        });
        setSelectedTrans()
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTransDetail({ ...transDetail, [name]: value });
    }
    const handleFileSelect = (event, id) => {
        const file = event.target.files[0];
        if (file) {
            setAttachmentList((prevList) => [
                ...prevList.map((attachment) =>
                    attachment.id === id ? { ...attachment, fileName: file.name, file: file } : attachment
                ),
                { id: Date.now(), fileName: '', remarks: '' },
            ]);
        }
    };
    const handleView = (file) => {
        if (file && file instanceof File) {
            setPreviewImage(URL.createObjectURL(file));
            setPreviewModal(true);
        } else {
            console.error("No valid file to preview");
        }
    };
    const handleDelete = (id) => {
        const updatedList = attachmentList.filter((attachment) => attachment.id !== id);
        setAttachmentList(updatedList);
    };
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setTransDetail({
            ...transDetail,
            transectionDate: formattedDate,
        });
    }
    const handleDeleteAlocate = (index) => {
        const updatedList = [...alocatedList];
        updatedList.splice(index, 1);
        setAlocatedList(updatedList);
    };
    const handleSave = async () => {
        try {
            setloader(true);
            const currentDatetimeUTC = new Date().toISOString();
            const allocationDetailsList = alocatedList?.map(item => {
                return {
                    leaseNo: item?.dta?.LeaseNo,
                    property_No: item?.dta?.Property_No,
                    property_name: item?.dta?.Property_name,
                    unit_No: item?.dta?.Unit_No,
                    tenantNo: item?.dta?.TenantNo || "0",
                    tenantName: item?.dta?.TenantName || "0",
                    mobileNo: item?.dta?.MobileNo || "0",
                    installment_Desc: item?.dta?.Installment_Desc || "0",
                    receiptType: item?.transectionType?.label || "0",
                    refundAmount: item?.dta?.ActualAmountPaid,
                    drawnOnBank: item?.dta?.DrawnOnBank || "0",
                    bankName: item?.dta?.BankName || "0",
                    remarks: item?.remarks || "0",
                    receiptNo: item?.dta?.ReceiptNo,
                    accountCode: "0",
                    accountName: "0",
                    chequeNo: item?.dta?.ChequeNo || "0",
                    payee: item?.payee || "0",
                    lrId: item?.dta?.LRId
                }
            });
            const totalRent = alocatedList?.reduce((sum, row) => sum + (parseFloat(row?.dta?.ActualAmountPaid) || 0), 0);
            const total = alocatedList?.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0);

            const body = {
                leaseReverseMain: {
                    allocationDetailsList: allocationDetailsList,
                    leaseReverseReceipt: {
                        unallocatedId: 0,
                        propertyId: alocatedList[0]?.dta.Property_No,
                        propertyName: alocatedList[0]?.dta.Property_name,
                        unitNo: alocatedList[0]?.dta.Unit_No,
                        customerNo: alocatedList[0]?.dta.TenantNo || "0",
                        customerName: alocatedList[0]?.dta.TenantName || "0",
                        resvNo: "0",
                        receiptType: alocatedList[0]?.transectionType.label || "0",
                        paymentDate: alocatedList[0]?.dta.PaymentDate,
                        receiptNo: alocatedList[0]?.dta.ReceiptNo,
                        unallocatedAmount: alocatedList[0]?.dta.ActualAmountPaid,
                        remarks: alocatedList[0]?.remarks || "0",
                        exp1: "0",
                        exp2: "0",
                        exp3: "0",
                        exp4: "0",
                        exp5: alocatedList[0]?.dta.Exp5,
                        modifiedBy: "0",
                        modifiedOn: currentDatetimeUTC
                    },
                    receiptDetailsList: [
                        {
                            lrId: 0,
                            leaseNo: "0",
                            property_No: "0",
                            property_name: "0",
                            unit_No: "0",
                            tenantNo: "0",
                            tenantName: "0",
                            receiptNo: "0",
                            installment_Desc: "0",
                            actualAmountPaid: 0,
                            exp5: "0",
                            paymentDate: currentDatetimeUTC,
                            paymentMethod: "0",
                            ccType: "0",
                            chequeNo: "0",
                            chequeDate: currentDatetimeUTC,
                            drawnOnBank: "0",
                            bankName: "0",
                            mobileNo: "0"
                        }
                    ],
                    // leaseAttachmentList: [
                    //     {
                    //         recordId:0,
                    //         leaseNo:"0",
                    //         description:"0",
                    //         description_BI:"0",
                    //         filename:"0",
                    //         folder:"0",
                    //         exp1:"0",
                    //         xp2:"0",
                    //         exp3:"0",
                    //         modifiedBy:"0",
                    //         modifiedOn:currentDatetimeUTC,
                    //         createdBy:"0",
                    //         createdOn:currentDatetimeUTC,
                    //         docPic: "iVBORw0KGgoAAAANSUhEUgAAA...",
                    //         clearDocImage:true
                    //     }
                    // ],
                    allocatedAmt: totalRent,
                    totalAmt: total,
                    allocation: totalRent,
                    payee: alocatedList[0]?.payee || "0",
                    transactionType: alocatedList[0]?.transectionType?.label || "0",
                    transactionDate: alocatedList[0]?.transectionDate,
                    narationType: alocatedList[0]?.narration?.label || "0",
                    remarks: alocatedList[0]?.remarks || "0",
                }
            }
            const postRes = await apiService.post("POST_LEASE_REVERSE", body);
            if (postRes?.data?.statusCode === 201) {
                toast.success(`Receipt Reversed successfully`);
                window.location.reload();
                setloader(false);
                handleClearFilters()
            } else {
                setloader(false);
            }
        } catch (error) {
            setloader(false);

            console.error("Error Save Data", error);
        }
    }
    return (
        <div className='p-3'>
            <div className="border-box2 p-2" style={{ borderRadius: '8px' }}>
                <div className="end">
                    <div className="d-flex gap-2 ">
                        {loading === true ? (
                            <div className="mainbtn flex-end gap-2 w-50">
                                <ClipLoader color="#ffffff" className="mt-1" size={25} />
                            </div>
                        ) : (
                            <div className="mainbtn flex-end gap-2 w-50" onClick={handleSave}>
                                <FaSave color="#fff" className="center mt-1 mx-2" />
                                <div className="center">Save</div>
                            </div>
                        )}
                        <div className="mainbtnRed flex-end gap-2 w-50" >
                            <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                            <div className="center">Reset</div>
                        </div>
                        <div className="mainbtnSecondary flex-end gap-2 w-50" onClick={handleBackClick}>
                            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
                            <div className="center">Back</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
                <div className="nav nav-pills overslid d-flex gap-4">
                    <div className={`dashitems sidebar-text center ${activeTab === 0 ? "sideActive" : ""}`} onClick={() => handleTabClick(0)}>
                        Search Tenant
                    </div>
                    <div className={`dashitems sidebar-text center  ${activeTab === 1 ? "sideActive" : ""}`} onClick={() => handleTabClick(1)}>
                        Attachment
                    </div>
                </div>
            </div>
            {gridVisibility[0] && (
                <div className=''>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setFilterTab(!FilterTab)}>
                            <div className='h6 pt-1'>Search Parameters</div>
                        </div>
                        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                                <div className="form-group grid-contain ">
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Property</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={transData?.Proprty}
                                            options={proprtyList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                            onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Unit No</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={transData.unitNo}
                                            options={unitList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                            onChange={(selectedOption) => handleUitNo(selectedOption)}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Lease No</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={transData?.leaseNo}
                                            options={leaseList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                            onChange={(selectedOption) => handleLeaseNo(selectedOption)}
                                        />
                                    </div>
                                    <div className='d-flex gap-1'>
                                        <div className="mainbtnGry flex-end gap-2 w-50" onClick={handleTransSearch}>
                                            <IoSearchOutline color="#fff" className="center mt-2 mx-2" />
                                            <div className="center">Search</div>
                                        </div>
                                        <div className="mainbtnRed flex-end gap-2 w-50" onClick={handleClearFilters} >
                                            <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                                            <div className="center">Reset</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='gridshad mt-1'>
                        <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                            <div className="ag-theme-quartz" style={{ height: 400 }}>
                                <AgGridReact
                                    getRowStyle={(params) => {
                                        if (params.node.rowIndex % 2 === 0) {
                                            return { background: '#F0EDF5' };
                                        } else {
                                            return { background: '#fff' };
                                        }
                                    }}
                                    rowData={dataList}
                                    enableFilter={true}
                                    floatingFilter={true}
                                    columnDefs={columnDefs}
                                    onSelectionChanged={onSelectionChanged}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="cost-center-section mt-3">
                        <div className="d-flex cursor-pointer slide-header"
                            onClick={() => setScodTab(!scondTab)}>
                            <div className='h6 pt-1'>Allocate Details</div>
                        </div>
                        <div className={`slide-content ${scondTab ? 'open' : 'closed'}`}>
                            <div className={`border-box2 p-3 ${scondTab ? 'slide-in' : 'slide-out'}`}>
                                <div className="form-group grid-contain ">
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Allocate Amt</label>
                                        <input type="text"
                                            value={transDetail?.allocateAmt}
                                            name="ActualAmountPaid" readOnly
                                            className="p-2 form-control w-75" />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Total</label>
                                        <input type="text"
                                            value={transDetail?.total}
                                            name="checkNo" readOnly
                                            className="p-2 form-control w-75" />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Allocation</label>
                                        <input type="text"
                                            value={transDetail?.allocateAmt} readOnly
                                            name="checkNo"
                                            className="p-2 form-control w-75" />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Transection Type</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={transDetail.transectionType}
                                            options={transectionType?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                                            onChange={(selectedOption) => handleTransectionType(selectedOption)}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Transection Date</label>
                                        <DatePicker
                                            todayButton="Today"
                                            selected={transDetail.transectionDate}
                                            onChange={(date) => handlePeriodFromChange({ name: 'transectionDate', value: date })}
                                            dateFormat="dd-MMM-yyyy"
                                            className="p-2 form-control w-100"
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Payee</label>
                                        <input type="text"
                                            value={transDetail?.payee}
                                            onChange={handleInputChange}
                                            name="payee"
                                            className="p-2 form-control w-75" />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start"> Narration</label>
                                        <Select
                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 5,
                                                padding: 9
                                            })}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                                    color: state.isFocused ? '#000 ' : '#000',
                                                    ':hover': {
                                                        backgroundColor: '#F5F5F5',
                                                        color: '#000 ',
                                                    },
                                                }),
                                            }}
                                            className="w-75 p-0"
                                            value={transDetail.narration}
                                            options={narrationList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                                            onChange={(selectedOption) => handleNarrationChange(selectedOption)}
                                        />
                                    </div>
                                    <div className="d-flex">
                                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Remarks</label>
                                        <input type="text"
                                            value={transDetail?.remarks}
                                            onChange={handleInputChange}
                                            name="remarks"
                                            className="p-2 form-control w-75" />
                                    </div>
                                    <div className='d-flex gap-1'>
                                        <div className="mainbtnGry flex-end gap-2 w-50" onClick={handleAllocate}>
                                            <IoSearchOutline color="#fff" className="center mt-1 mx-2" />
                                            <div className="center">Allocate</div>
                                        </div>
                                        <div className="mainbtnRed flex-end gap-2 w-50" onClick={handleCleareAllocate} >
                                            <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                            <div className="center">Reset</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='table-container' style={{ overflowX: 'auto', height: "600px" }}>
                        <table className='table table-bordered gridshad'>
                            <thead className='dynoTable'>
                                <tr>
                                    <th>Action</th>
                                    <th>Lease No</th>
                                    <th>Property No</th>
                                    <th>Property</th>
                                    <th>Unit No</th>
                                    <th>Tenant No</th>
                                    <th>Tenant Name</th>
                                    <th>Mobile</th>
                                    <th>Installment</th>
                                    <th>Receipt Type</th>
                                    <th>Refund Amount</th>
                                    <th>Drawn Bank</th>
                                    <th>Deposite Bank</th>
                                    <th>Remarks</th>
                                    <th>Receipt No</th>
                                    <th>Account Code</th>
                                    <th>Account</th>
                                    <th>Cheque No</th>
                                    <th>Payee</th>
                                    <th>LRID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(alocatedList) && alocatedList.map((data, index) => {
                                    const dta = data.dta;
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <div className='center mt-2'>
                                                    <FaTrash
                                                        size={20}
                                                        style={{ cursor: "pointer", color: "red" }}
                                                        onClick={() => handleDeleteAlocate(index)}
                                                    />
                                                </div>
                                            </td>
                                            <td><input value={data?.dta?.LeaseNo} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.Property_No} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.Property_name} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.Unit_No} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.TenantNo} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.TenantName} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.MobileNo} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.Installment_Desc} className='p-1' disabled /></td>
                                            <td><input value={data?.transectionType?.label || "--"} className='p-1' disabled /></td>
                                            <td><input value={(data.allocation || 0)?.toFixed(currencyPrecision?.decimalNumbers)} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.DrawnOnBank} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.BankName} className='p-1' disabled /></td>
                                            <td><input value={data.remarks} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.ReceiptNo} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.Exp5} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.BankName} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.ChequeNo} className='p-1' disabled /></td>
                                            <td><input value={data.payee || ""} className='p-1' disabled /></td>
                                            <td><input value={data?.dta?.LRId} className='p-1' disabled /></td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            {gridVisibility[1] && (
                <div className='border-box2 p-4' style={{ borderRadius: "8px" }}>
                    <div className="col d-flex justify-content-between">
                        <input className="form-Input w-100" placeholder='Enter Description' />
                    </div>
                    <div className="pt-2">
                        <table>
                            <thead className="dynoTable">
                                <tr>
                                    <th>File Name</th>
                                    <th>Remarks</th>
                                    <th>Upload</th>
                                    <th>View</th>
                                    <th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attachmentList?.map((attachment, index) => (
                                    <tr key={attachment.id}>
                                        <td className='m-0 p-0 col-6'><input className='p-0 mt-2' type='text' disabled value={attachment.fileName} style={{ width: "100%" }} /></td>
                                        <td className=' col-6'>
                                            <input type="text" className='p-0 mt-2' value={attachment.remarks}
                                                onChange={(e) => {
                                                    const updatedList = attachmentList?.map((item) =>
                                                        item.id === attachment.id ? { ...item, remarks: e.target.value } : item
                                                    );
                                                    setAttachmentList(updatedList);
                                                }}
                                                style={{ width: '100%' }}
                                            />
                                        </td>
                                        <td>
                                            <button className='mainbtn mt-2' onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit"><div>Upload</div></button>
                                            <input
                                                type="file" className='p-0'
                                                style={{ display: 'none' }}
                                                onChange={(e) => handleFileSelect(e, attachment.id)}
                                                id={`fileInput-${attachment.id}`}
                                                accept=".png,.jpg,.jpeg,.gif,.bmp,.pdf,.doc,.docx"
                                            />
                                        </td>
                                        <td><button className='mainbtnRed mt-2 mx-2 ' onClick={() => handleView(attachment.file)} disabled={!attachment.fileName}>
                                            <div>View</div></button></td>
                                        <td>
                                            <button onClick={() => handleDelete(attachment.id)} disabled={!attachment.fileName} className='mainbtnSecondary mt-2'>
                                                <div>Delete</div></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
            <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Image Preview</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}
                </Modal.Body>
            </Modal>
        </div>
    );
};
export default ReverseReceipt;